module.exports = __webpack_public_path__ + "img/regular-desc@3x.940d5008.png";